import { useState } from 'react'
import styled from 'styled-components'
import { CardElement } from '@stripe/react-stripe-js'
import { ElementChangeResponse } from '@stripe/stripe-js'
import { colors } from 'shared/lib'
import { InputBox, Error } from 'shared/components/Input/InputStyles'

type CreditCardInputProps = {
  hideIcon?: boolean
  marginTopOnly?: boolean
  onComplete(isComplete: boolean): void
  qaAttr?: string
  title: string
}

const CreditCardInput = ({
  hideIcon = false,
  marginTopOnly = false,
  onComplete,
  qaAttr,
  title,
}: CreditCardInputProps) => {
  const [error, setError] = useState('')
  const hasError = !!error

  const handleChange = (event: ElementChangeResponse) => {
    const { error: stripeError, complete } = event
    onComplete(complete)
    setError(stripeError?.message ? stripeError.message : '')
  }

  return (
    <StyledInputBox $marginTopOnly={marginTopOnly}>
      <InputHeader>
        <label htmlFor="card-element">{title}</label>
        {error && (
          <Error data-qa={`${qaAttr}ErrorInLine`} as="span">
            {error}
          </Error>
        )}
      </InputHeader>
      <CardBox error={hasError}>
        <CardElement id="card-element" onChange={handleChange} options={{ hideIcon }} />
      </CardBox>
    </StyledInputBox>
  )
}

const CardBox = styled.div<{ error: boolean }>`
  border: 1px solid ${({ error }) => (error ? `${colors.FC2_RED}` : `${colors.FC2_LIGHTEST_GREY}`)};
  color: ${colors.FC2_BLACK};
  font-size: 14px;
  margin-top: 5px;
  min-height: 40px;
  padding: 10px 15px;
`
const InputHeader = styled.div`
  display: flex;
  font-weight: 500;
  justify-content: space-between;
  line-height: 16px;
`
const StyledInputBox = styled(InputBox)<{ $marginTopOnly: boolean }>`
  margin: ${({ $marginTopOnly }) => ($marginTopOnly ? '20px 0 0 0' : '15px 0')};
`

export default CreditCardInput
